import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BackgroundEffects from './components/BackgroundEffects';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import WhyChooseUs from './components/WhyChooseUs';
import Partners from './components/Partners';
import FAQs from './components/FAQs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen text-slate-100 selection:bg-brand-cyan/30 selection:text-white relative">
      {/* Dynamic Background Effects */}
      <BackgroundEffects />

      {/* Scroll restoration helper */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Navbar />

      {/* Page Sections */}
      <main className="relative z-10">
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              {/* <Partners /> */}
              <WhyChooseUs />
              {/* <Testimonials /> */}
              {/* <FAQs /> */}
            </>
          } />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      {/* Site Footer */}
      <Footer />
    </div>
  );
}

export default App;
